<template>
  <a-spin :spinning="loading">
    <div
      class="lookPPT"
      :style="{
        backgroundImage: 'url(' + imagePath.myBGI + ')',
      }"
    >
      <common-header></common-header>
      <div class="lookPPTContent">
        <div class="path">
          <!-- {{ path.classLevelName }} > {{ path.firSubName }} >
        {{ path.secSubName }} ><span>{{ slidesInfo.slidesName }}</span> -->
          <address-bar :path="path"></address-bar>
          <div class="homeCard">
            <div class="cardBtn cp" @click="handlePosterShow">
              <img :src="imagePath.shareBtn" alt="" />
              <span>家园共育卡</span>
            </div>
            <div class="homeCardBox" v-show="posterIsShow">
              <img
                :src="imagePath.downloadBtn"
                class="cardDownloadBtn cp"
                @click="downLoad"
              />
              <div id="poster">
                <img :src="imagePath.posterBGI" class="posterBGI" />
                <div class="cardTitle">逻辑狗·家园共育卡</div>
                <div class="cardName">{{ slidesInfo.slidesName }}</div>
                <div class="QRCode" ref="qrCodeUrl"></div>
              </div>
            </div>
            <div
              class="homeCardMask"
              v-show="posterIsShow"
              @click="handlePosterShow"
            ></div>
          </div>
        </div>

        <div v-if="isJudgeSlides" ref="h5IframeBox" class="h5IframeBox">
          <iframe
            ref="h5Iframe"
            v-if="isJudgeSlides"
            id="h5Iframe"
            class="h5Iframe"
            :src="url"
            frameborder="0"
            allowfullscreen
          ></iframe>
          <div
            v-if="isJudgeSlides"
            class="fSBtn"
            id="fSBtn"
            ref="fSBtn"
            @click="handleFullScreen"
          ></div>
        </div>
        <div v-else class="iframeBox" ref="iframeBox">
          <!-- 课件全屏预览遮挡按钮 -->
          <div
            ref="fullScreenBtn"
            style="
              position: absolute;
              top: 5px;
              right: 35px;
              width: 28px;
              height: 19px;
              cursor: pointer;
            "
            @click="handleFullScreen"
          ></div>

          <!-- 遮挡播放按钮 -->
          <div
            ref="maskLayer"
            style="
              position: absolute;
              left: 98px;
              top: 33px;
              width: 48px;
              height: 58vh;
              cursor: pointer;
            "
            @click="handleFullScreen"
          ></div>

          <!-- 永中云预览 -->
          <iframe
            id="myIframe"
            :src="url"
            ref="myIframe"
            class="myIframe"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>

        <!-- <viewFile v-if="jwpsUrl" :wpsUrl="jwpsUrl" :token="jtoken" /> -->
      </div>
      <full-screen ref="fullScreen"></full-screen>
    </div>
    <!-- 登录超过人数提醒 -->
    <a-modal
      title="提醒"
      :closable="false"
      :visible="visible"
      :centered="true"
      @ok="loginOut"
      @cancel="loginOut"
    >
      <h3>该账号登录人数超过限制您已下线，请重新登录。</h3>
      <p>（若账号安全度降低，请及时修改密码）</p>
      <template slot="footer">
        <a-button type="primary" @click="loginOut">知道了</a-button>
      </template>
    </a-modal>
  </a-spin>
</template>

<script>
import fullScreen from "./fullScreen.vue";
import html2canvas from "html2canvas";
// import viewFile from "@/components/wpsView/view";
import AddressBar from "@/components/addressBar";
import CommonHeader from "@/components/header/index";
import imagePath from "@/utils/imagePath";
import {
  querySlidesInfo,
  queryPath,
  // getQRCode,
  getUtilsPreview,
  getViewUrlWebPath,
  // getWpsUtilsPreview,
  handleVerifyAuthCount
} from "@/api/home";
import { logout } from "@/api/login.js";
import QRCode from "qrcodejs2";

const fileSuffix = [
  "xls",
  "xlt",
  "et",
  "xlsx",
  "xltx",
  "csv",
  "xlsm",
  "xltm",
  "doc",
  "dot",
  "wps",
  "wpt",
  "docx",
  "dotx",
  "docm",
  "dotm",
  "ppt",
  "pptx",
  "pptm",
  "ppsx",
  "ppsm",
  "pps",
  "potx",
  "potm",
  "dpt",
  "dps",
  "pdf"
];
// 生成快照
const convertToImage = (container, options = {}) => {
  // 设置放大倍数
  // const scale = window.devicePixelRatio;
  const scale = 4;
  const dpi = window.devicePixelRatio * 4; // 将分辨率提高到特定的DPI 提高四倍
  // 传入节点原始宽高
  const width = container.offsetWidth;
  const height = container.offsetHeight;

  // html2canvas配置项
  const ops = {
    scale,
    dpi,
    width,
    height,
    useCORS: true,
    allowTaint: true,
    backgroundColor: null, // 设置图片背景为透明
    ...options
  };

  return html2canvas(container, ops).then((canvas) => {
    // 返回图片的二进制数据
    return canvas.toDataURL("image/png");
  });
};

export default {
  name: "LookPPT", // 查看课件
  components: {
    CommonHeader,
    // viewFile,
    AddressBar,
    fullScreen
  },
  data() {
    return {
      visible: false,
      imagePath,
      fileSuffix, // 查看格式
      slidesInfo: {}, // 课件信息
      jwpsUrl: "", // wps url
      jtoken: "", // wps token
      path: {}, // 地址栏
      QRCode: "",
      posterIsShow: false, // 海报显示
      url: "",
      isJudgeSlides: true,
      loading: false
    };
  },
  async created() {
    const isTrue = await this.handleVerifyAuthCount();
    if (!isTrue) {
      this.visible = true;
      return;
    }
    await this.querySlidesInfo(this.$route.query.id);
  },
  mounted() {
    window.addEventListener("resize", this.handleSetQrCodeWidth);
  },
  methods: {
    // 给二维码做适配，根据当前视口宽度
    handleSetQrCodeWidth() {
      const width = window.innerWidth;
      const eleWidth = `${(width * 121.45) / 1920}px`;
      this.$refs.qrCodeUrl.childNodes[1].style.width = eleWidth;
      this.$refs.qrCodeUrl.childNodes[1].style.height = eleWidth;
    },
    // 退出登录
    async loginOut() {
      const { data, status, msg } = await logout();
      if (status === 200) {
        console.log(data, "logout");
        localStorage.removeItem("token");
        await this.$router.push("/login");
      }else {
        this.$message.error(msg)
      }
    },
    // 校验是否超过使用人数
    async handleVerifyAuthCount() {
      const { status } = await handleVerifyAuthCount();
      if (status === 200) {
        return true;
      } else {
        return false;
      }
    },
    // 因为永中全屏时会出现文字被图片遮挡的问题，并且无法获取到永中云预览中的元素，只能拿两个div遮住全屏按钮，这个方法就是通过控制iframe的大小，实现假全屏
    handleFullScreen() {
      if (!this.isJudgeSlides) {
        if (this.$refs.iframeBox.className === "iframeBox") {
          this.$refs.iframeBox.className = "iframeBoxPlus";
          this.$refs.myIframe.className = "myIframePlus";
          this.$refs.fullScreenBtn.style =
            "position: fixed;top: 7px;right: 35px;z-index: 10000000;width: 28px;height: 19px;cursor: pointer;";
          this.$refs.maskLayer.style =
            "position: fixed;left: 100px;top: 33px;z-index: 1000000;width: 48px;height: 100vh;cursor: pointer;";
        } else {
          this.$refs.iframeBox.className = "iframeBox";
          this.$refs.myIframe.className = "myIframe";
          this.$refs.fullScreenBtn.style =
            "position: absolute;top: 5px;right: 35px;width: 28px;height: 19px;cursor: pointer;";
          this.$refs.maskLayer.style =
            "position: absolute;left: 98px;top: 33px;width: 48px;height: 58vh;cursor: pointer;";
        }
      } else {
        if (this.$refs.h5IframeBox.className === "h5IframeBox") {
          this.$refs.h5IframeBox.className = "h5IframeBox2";
          this.$refs.h5Iframe.className = "h5Iframe2";
          this.$refs.fSBtn.className = "fSBtn2";
          this.$refs.fullScreen.fullScreen();
        } else {
          this.$refs.h5IframeBox.className = "h5IframeBox";
          this.$refs.h5Iframe.className = "h5Iframe";
          this.$refs.fSBtn.className = "fSBtn";
          this.$refs.fullScreen.fullScreenOut();
        }
      }
    },
    // 获取二维码
    creatQrCode(QrCodeUrl) {
      //清除之前的二维码
      this.$refs.qrCodeUrl.innerHTML = "";
      new QRCode(this.$refs.qrCodeUrl, {
        text: QrCodeUrl, // 需要转换为二维码的内容
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
      this.handleSetQrCodeWidth();
    },
    // 获取二维码id
    getQRCodeUrl(id) {
      this.creatQrCode(`http://luojigou.vip/singlepage/#/homeCard?id=${id}`);
    },
    // 海报显示
    handlePosterShow() {
      // this.getQRCode();
      this.getQRCodeUrl(this.slidesInfo.slidesId);
      this.posterIsShow = !this.posterIsShow;
    },
    // 下载海报
    async downLoad() {
      const element = document.getElementById("poster");
      const imgBlobData = await convertToImage(element);
      if (imgBlobData) {
        const el = document.createElement("a");
        // 设置 href 为图片经过 base64 编码后的字符串，默认为 png 格式
        el.href = imgBlobData;
        el.download = "poster.png";
        // 创建一个点击事件并对 a 标签进行触发
        const event = new MouseEvent("click");
        el.dispatchEvent(event);
      }
    },
    // 查询地址栏
    async queryPath(id) {
      const { data, status, msg } = await queryPath(id);
      if (status === 200) {
        this.path = data;
        this.path.slidesName = this.slidesInfo.slidesName;
        // console.log(data, "queryPath");
      } else {
        this.$message.error(msg);
      }
    },
    handleJudgeSlides(val) {
      const str = val.slidesUrl.split("").reverse().join("").slice(0, 4);
      if (str === "lmth") {
        this.url = val.slidesUrl;
        this.isJudgeSlides = true;
      } else {
        this.getUtilsPreview();
        this.isJudgeSlides = false;
      }
    },
    // 查询课件信息
    async querySlidesInfo(id) {
      this.loading = true;
      const { data, status, msg } = await querySlidesInfo(id);
      if (status === 200) {
        this.slidesInfo = data;
        this.handleJudgeSlides(data);
        // this.getViewUrlWebPath();
        await this.queryPath(this.slidesInfo.catId);
        // this.getUtilsPreview();
        // console.log(data, "querySlidesInfo");
      } else {
        this.$message.error(msg);
      }
      this.loading = false;
    },
    // 获取永中云签名
    async getUtilsPreview() {
      // watermark: ["中德智慧教育"],
      const { data, msg, status } = await getUtilsPreview({
        fileVersionId: [this.slidesInfo.fileVersionId],
        isCopy: ["1"]
      });
      if (status === 200) {
        // console.log(data, 'getUtilsPreview')
        this.url = this.getYoZoViewFile(data);
        // console.log(this.url, "this.url");
      } else {
        this.$message.error(msg);
      }
    },
    // 获取永中云预览地址
    getYoZoViewFile(sign) {
      // &watermark=中德智慧教育
      console.log(
        "永中云预览地址：",
        `https://eic.yozocloud.cn/api/view/file?fileVersionId=${this.slidesInfo.fileVersionId}&appId=yozohX360ZlX7989&sign=${sign}&isCopy=1`
      );
      return `https://eic.yozocloud.cn/api/view/file?fileVersionId=${this.slidesInfo.fileVersionId}&appId=yozohX360ZlX7989&sign=${sign}&isCopy=1`;
    },
    // 获取web地址(wps)
    async getViewUrlWebPath() {
      //   if (!this.checkFileUrl()) {
      //     return;
      //   }
      //   this.loading = true;
      const params = {
        fileUrl: this.slidesInfo.slidesUrl
      };
      const { data, code } = await getViewUrlWebPath(params);
      if (code === 200) {
        // 跳转 使用sessionStorage，避免关键信息在ip中暴露
        // 使用push会停留当前页面，故不采纳
        // params 传递参数，子组件无法渲染iframe组件，故不采纳
        // sessionStorage.setItem("wpsUrl", data.wpsUrl);
        // sessionStorage.setItem("token", data.token);
        this.jwpsUrl = data.wpsUrl;
        this.jtoken = data.token;
        // const jump = this.$router.resolve({ name: "ViewFile" });
        // window.open(jump.href, "_blank");
      } else {
        this.$message.error(data);
      }
    }
    // 获取wps签名
    // async getWpsUtilsPreview() {
    //   const params = {
    //     appid
    //   };
    //   const { data, msg, status } = await getWpsUtilsPreview(params);
    //   if (status === 200) {
    //     console.log(data, "getWpsUtilsPreview");
    //   } else {
    //     this.$message.error(msg);
    //   }
    // },
  }
};
</script>

<style lang="less" scoped>
/*设置全屏样式*/
#myFrame:-webkit-full-screen {
  width: 100%;
  height: 100%;
}

.lookPPT {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;

  .lookPPTContent {
    margin: 0 auto;
    width: 1200px;

    .path {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 64px;
      margin-bottom: 32px;
      height: 24px;
      line-height: 24px;
      font-size: 24px;
      color: #333333;

      .homeCard {
        display: flex;
        align-items: center;
        position: relative;
        height: 68px;

        .cardBtn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 182px;
          height: 48px;
          background: #66a8f5;
          border-radius: 31px;

          img {
            margin-right: 10px;
            width: 22px;
            height: 22px;
            object-fit: cover;
          }

          span {
            color: #ffffff;
            font-weight: 500;
            font-size: 22px;
          }
        }

        .homeCardBox {
          position: absolute;
          left: -84px;
          top: 68px;
          z-index: 3;
          width: 350px;
          height: 500px;

          .cardDownloadBtn {
            position: absolute;
            top: 38.5px;
            right: 20px;
            z-index: 10;
            width: 22px;
          }

          #poster {
            position: relative;
            width: 350px;
            height: 500px;
            overflow: hidden;
            border-radius: 10px;

            .posterBGI {
              position: absolute;
              z-index: 1;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .cardTitle {
              position: relative;
              z-index: 9;
              margin-left: 20px;
              margin-top: 20px;
              height: 33px;
              font-size: 24px;
              font-weight: 600;
              color: #333333;
              line-height: 33px;
            }

            .cardName {
              position: relative;
              z-index: 9;
              margin-top: 5px;
              margin-left: 20px;
              height: 22px;
              font-size: 16px;
              font-weight: 400;
              color: #333333;
              line-height: 22px;
            }

            .QRCode {
              position: relative;
              z-index: 9;
              margin: 0 auto;
              margin-top: 96px;
              display: block;
              width: 122px;
              height: 122px;
              object-fit: cover;
            }
          }
        }

        .homeCardMask {
          position: fixed;
          top: 0;
          left: 0;
          z-index: 2;
          width: 100vw;
          height: 100vh;
        }
      }
    }

    .PPTUrl {
      width: 1201px;
      height: 669px;
      object-fit: cover;
    }
  }
}

.iframeBox {
  position: relative;
  width: 62.5vw;
  height: 62vh;
}

.iframeBoxPlus {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
}

.myIframe {
  width: 62.5vw;
  height: 62vh;
}

.myIframePlus {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
}

.fullScreenBtn {
  position: absolute;
  top: 40px;
  right: 35px;
  width: 28px;
  height: 19px;
  cursor: pointer;
  background-color: #000;
}

.fullScreenBtn2 {
  position: fixed;
  top: 7px;
  right: 35px;
  z-index: 1000000;
  width: 28px;
  height: 19px;
  cursor: pointer;
  background-color: #000;
}

.maskLayer {
  position: absolute;
  left: 98px;
  top: 90px;
  width: 2.5vw;
  height: 58vh;
  background-color: #000;
}

.maskLayer2 {
  position: fixed;
  left: 100px;
  top: 30px;
  z-index: 1000000;
  width: 2.5vw;
  height: 100vh;
  background-color: #000;
}

.h5IframeBox {
  position: fixed;
  top: 50%;
  left: 50%;
  height: 590px;
  transform: translate(-50%, -35%);
  // border: 1px solid #000;
  // overflow: hidden;
}

.h5IframeBox2 {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100vw;
  height: 100vh;
  // border: 1px solid #000;
  overflow: hidden;
  background-color: #fff;
}

.h5Iframe {
  position: relative;
  top: -15px;
  width: 1055.2896px;
  height: 673.6px;
}

.h5Iframe2 {
  position: relative;
  width: 100vw;
  height: 104.5vh;
}

.fSBtn {
  position: absolute;
  bottom: 15px;
  right: 25px;
  width: 45px;
  height: 45px;
  background-image: url("~@/static/images/home/courseDetails/fullScreenBtn.png");
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
}

.fSBtn2 {
  position: absolute;
  top: 25px;
  left: 25px;
  width: 70px;
  height: 70px;
  background-image: url("~@/static/images/home/courseDetails/returnFullScreen.png");
  background-repeat: no-repeat;
  cursor: pointer;
}
</style>
